/**
  Handles drop-down menus.
  all functions begin with globalMenu
*/

function globalMenuNavObserver(navMenuContainer) {
    const lastItem = document.querySelector('#menuGlobal-list > li:last-child');

        // check to see if the menu fits without scrolling horizontally
        let observer = new IntersectionObserver(
            function (entries, observer) { 
                let menuFits = false;
                entries.forEach(function(entry) {
                    if(entry.isIntersecting){
                        menuFits = true;
                        console.log('menu fits running', menuFits)
                    }
                });
    
                if(! menuFits) {
                    // navMenuContainer.classList.remove('menu-does-not-fit');
                    navMenuContainer.classList.add('menu-does-not-fit');                
                }
            }, 
            {   
                root: navMenuContainer,
                rootMargin: '0px',
                threshold: 1.0
            }
        );
    
        observer.observe(lastItem);
       
        lastItem.addEventListener("animationend", function() {
            navMenuContainer.classList.remove('menu-does-not-fit');
        }, false);
}

function globalMenuClickHandler(ev,itemsWithChildren) {
        const itemWithSubmenuClicked = ev.target.closest('.menuGlobal .menu-item-has-children');

        // a click anywhere else in the document hides the submenu if displayed
        if(! itemWithSubmenuClicked) {
            itemsWithChildren.forEach( function(itemWithChildren) {
                itemWithChildren.classList.remove('show-sub-menu');
            });

            return;
        }

        // if link inside submenu clicked follow link
   
        if(ev.target.closest('.menuGlobal .sub-menu')) {
            return;
        }

        ev.preventDefault();

        const submenu = itemWithSubmenuClicked.querySelector('.sub-menu');
        const dims = itemWithSubmenuClicked.getBoundingClientRect();

       // console.log(dims.bottom);

        let left = Math.round(dims.left);
        const top =  Math.round(dims.bottom);

        if(screen.width - left < 250) {
            left = screen.width - 270;
        }

        if(left < 0) {
            left = 10;
        }
 
        submenu.style.left = left + 'px';
        submenu.style.top = top + 'px';

        itemWithSubmenuClicked.classList.toggle('show-sub-menu');
 }
  
export default function globalMenu() {

    const navMenu = document.getElementById('menu-global');
    const itemsWithChildren = navMenu.querySelectorAll('.menu-item-has-children');
    const navMenuContainer = document.querySelector('.menuGlobal-container');

    if(! navMenu || ! navMenuContainer) {
        console.log('#menu-global and/or .menuGlobal-container not present');
        return;
    }

    if(! itemsWithChildren.length) {
        return;
    }

    // only add observer and document event listener once
    if( navMenuContainer.getAttribute('data-listening')) {
       return;
    }

    globalMenuNavObserver(navMenuContainer);

    /*  adds a parent link for nav items with a submenu 

    let item;
    //let containerWidth = document.querySelector('.site-branding-top-strip').clientWidth;
    //Add "All" link to submenu that links to top level page
    itemsWithChildren.forEach( item => {
        let link = item.firstChild;
        let subMenu = item.querySelector('.sub-menu');
        console.log(item);
    //    subMenu.style.width = `${containerWidth}px`;

      //  li.innerHTML = `<a href="${link.href}">${link.textContent} - All</a>`;
      if(itemsWithChildren.length > 1) {
          let li = document.createElement('li');
          li.innerHTML = `<a href="${link.href}">Overview</a>`;
          subMenu.prepend(li);
      }
    }); */

  //  const compStyles = window.getComputedStyle(mobileHeaderEl);

  //  return compStyles.getPropertyValue('display') === 'flex';

    document.addEventListener('click', function(ev) { 
        globalMenuClickHandler(ev, itemsWithChildren);
    });

    navMenuContainer.setAttribute('data-listening', true);
}